export default __webpack_public_path__ + "static/media/global-icon-one.dc60048e.svg";